/** Dependency-free helpers shared by the block editor and the block player. */

export function formatFileSize(bytes: number): string {
    if (!bytes || bytes <= 0) return '';
    const units = ['B', 'KB', 'MB', 'GB'];
    const i = Math.min(units.length - 1, Math.floor(Math.log(bytes) / Math.log(1024)));
    return `${(bytes / Math.pow(1024, i)).toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
}

/** Only known players are embedded; everything else becomes a plain link in the player. */
export function getEmbedUrl(url: string): string | null {
    const yt = /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/.exec(url);
    if (yt) return `https://www.youtube-nocookie.com/embed/${yt[1]}`;
    const vimeo = /vimeo\.com\/(?:video\/)?(\d+)/.exec(url);
    if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}`;
    return null;
}

export function gridTemplate(columns: { width?: string }[]): string {
    if (columns.length === 2) {
        if (columns[0].width === '2/3') return '2fr 1fr';
        if (columns[0].width === '1/3') return '1fr 2fr';
    }
    return `repeat(${Math.max(columns.length, 1)}, minmax(0, 1fr))`;
}

